var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07482 2.23678C7.45334 1.47674 8.54699 1.47674 8.9255 2.23678L10.1862 4.76821C10.3365 5.07003 10.6271 5.27922 10.9632 5.32762L13.7822 5.73355C14.6286 5.85543 14.9665 6.88618 14.3541 7.47778L12.3142 9.44823C12.071 9.68316 11.96 10.0216 12.0174 10.3534L12.499 13.1357C12.6436 13.971 11.7588 14.6081 11.0018 14.2137L8.48035 12.9C8.17973 12.7434 7.8206 12.7434 7.51998 12.9L4.99857 14.2137C4.24154 14.6081 3.35675 13.971 3.50133 13.1357L3.98288 10.3534C4.04029 10.0216 3.92931 9.68316 3.68611 9.44823L1.64625 7.47779C1.0338 6.88618 1.37175 5.85543 2.21814 5.73355L5.03716 5.32762C5.37326 5.27922 5.66381 5.07003 5.81412 4.76821L7.07482 2.23678Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.751712c4d3ac6fad84062dd1e5296939.svg";
export { ForwardRef as ReactComponent };